import { useEffect, useState } from 'react';

declare global {
  interface Window {
    AF_SMART_SCRIPT: {
      generateOneLinkURL: (options: {
        oneLinkURL: string;
        webReferrer: string;
        afParameters: {
          mediaSource: { defaultValue: string; keys: string[] };
          channel: { defaultValue: string; keys: string[] };
          campaign: { defaultValue: string; keys: string[] };
          googleClickIdKey: string;
          afSub4: { keys: string[] };
          afSub2: { defaultValue: string; keys: string[] };
          afSub5: { defaultValue: string; keys: string[] };
          afCustom: { paramKey: string; defaultValue: string }[];
        };
      }) => {
        clickURL: string;
      } | null;
    };
  }
}

const oneLinkURL = 'https://simlocal.onelink.me/kIwv';

const mediaSource = { keys: ['utm_source'], defaultValue: 'non_paid' };
const channel = { keys: ['utm_medium'], defaultValue: 'non_paid' };
const campaign = { keys: ['utm_campaign'], defaultValue: 'non_paid' };

const webReferrer = 'af_sub1';
const afSub2 = { keys: ['utm_term'], defaultValue: 'non_paid' };
const afSub3GoogleClickIdKey = 'af_sub3';
const afSub4FacebookClickIdKey = { keys: ['fbclid'] };
const afSub5 = { keys: ['utm_content'], defaultValue: 'non_paid' };
const custom_ss_ui = { paramKey: 'af_ss_ui', defaultValue: 'true' };

export const useCreateStoreLink = () => {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    const effect = () => {
      try {
        const result = window.AF_SMART_SCRIPT?.generateOneLinkURL({
          oneLinkURL,
          webReferrer,
          afParameters: {
            mediaSource,
            channel,
            campaign,
            afSub2,
            googleClickIdKey: afSub3GoogleClickIdKey,
            afSub4: afSub4FacebookClickIdKey,
            afSub5,
            afCustom: [custom_ss_ui],
          },
        });
        setUrl(result?.clickURL || null);
      } catch {
        setUrl(null);
      }
    };

    effect();
  }, []);

  return url;
};
